import { FileListItem } from "@/components/IBFile/interface";
import axios from "axios";
import api from "..";
import { isSuccessResponseStatusCode } from "../handler";
import { CancelableApiResponse, IApiHandlerParams } from "../interface";
import { FileDeleteParams, FileLoaderParams, FileObjectItem, FileUploadParams } from "./interface";
import { fileUploadProgress, fileUploadEnd } from "@/modules/File/file-loading";
import { objectToFormdata } from "../other-request-handler";

export const $getFileObjects = async (
	body: FileLoaderParams,
	handler?: IApiHandlerParams
): Promise<FileObjectItem[]> => api
	.post('files/get-files', body, { handler })
	.then(response => response || []);

export const $uploadFileObject = async (
	payload: FileUploadParams
): Promise<CancelableApiResponse<FileObjectItem | null>> => {
	return $uploadFileAndTrackProgress(
		'files/upload-file',
		objectToFormdata({
			...payload.fileParams,
			file: payload.fileItem.file
		}),
		payload.fileItem
	);
};

export const $deleteFileObject = async (
	data: FileDeleteParams,
	handler?: IApiHandlerParams
): Promise<boolean> => api
	.delete('files/delete-file', {
		handler: { ...(handler || {}), returnData: false },
		request: { data }
	})
	.then(response => isSuccessResponseStatusCode(response?.status));

export const $uploadFileAndTrackProgress = <T, R extends FileObjectItem>(
	endpoint: string,
	payload: T,
	fileItem: FileListItem
): CancelableApiResponse<R | null> => {
	const cancelTokenSource = axios.CancelToken.source();

	return {
		cancelTokenSource,
		request: api
			.post(endpoint, payload, {
				handler: { disableLoader: true },
				request: {
					cancelToken: cancelTokenSource.token,
					onUploadProgress: fileUploadProgress(fileItem)
				}
			})
			.then(response => fileUploadEnd(fileItem)(response))
	};
};